const SettingsUrls = {
  GetByCodes: '/Settings/public/',
} as const;

export default SettingsUrls;
